/**
=========================================================
* Trakib - v2.1.0
=========================================================

* Product Page: https://www.trakib.com/product/material-dashboard-pro-react
* Copyright 2022 Trakib (https://www.trakib.com)

Coded by www.trakib.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState, useEffect, useContext } from "react";

// @mui material components
import Card from "@mui/material/Card";

// Trakib components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAlert from "components/MDAlert";

// Trakib examples
import DefaultLayout from "examples/LayoutContainers//DefaultLayout";
import DataTable from "examples/Tables/DataTable";
import MDButton from "components/MDButton";
import { Tooltip, IconButton, Icon } from "@mui/material";

import EditIcon from "@mui/icons-material/Edit";

import CrudService from "services/cruds-service";
import { useNavigate, useLocation } from "react-router-dom";
import { AuthContext } from "context";

import { AbilityContext } from "Can";
import { useAbility } from "@casl/react";
import { Can } from "Can";
import { subject } from "@casl/ability";
import i18n from "i18n";
import DefaultCell from "components/table/DefaultCell";
import { Add } from "@mui/icons-material";

function Faqs() {
  const { t } = i18n;
  let { state } = useLocation();
  const [meta, setMeta] = useState(null);
  const [page, setPage] = useState(1);
  const [sortVal, setSortVal] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [items, setItems] = useState([]);
  // const [showFilter, setShowFilter] = useState(false);
  const [limitChange, setLimitChange] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [filterUrl, setFilterUrl] = useState("");
  const [filterData, setFilterData] = useState(false);
  // const [notification, setNotification] = useState({
  //   value: false,
  //   text: "",
  // });

  const reqUrl = `items/faq?fields=id,translations.*,tags.tags_id.translations.name&page=${page}`;
  const navigate = useNavigate();
  const ability = useAbility(AbilityContext);
  const authContext = useContext(AuthContext);

  useEffect(() => {
    (async () => {
      setIsAdmin(await authContext.isCurrentUserAdmin());
    })();
  }, []);

  const getItems = async (filUrl) => {
    const response = await CrudService.getData(`${reqUrl}${filUrl}`);
    setItems(response.data);
    setMeta(response.meta);
  };

  useEffect(() => {
    if (limitChange) {
      setLimitChange(false);
      return; //to avoid do request two time when it true and false ;now it do only one time when it return to false
    }

    if (filterData) {
      setFilterData(false);
      return; //to avoid do request two time when it true and false ;now it do only one time when it return to false
    }

    let sortUrl = "";
    if (sortVal) {
      sortUrl = `&sort=${sortVal.desc ? "-" : "+"}${sortVal.id}`;
    }
    getItems(`${filterUrl}${sortUrl}`);
  }, [page, limitChange, sortVal, filterData]);

  useEffect(() => {
    if (page !== 1) setPage(1);
    else if (filterUrl !== "") setFilterData(true); // to do any action to fire useEffect which fire when filterData chenged to do getItems function and aproove that sort value exist
  }, [filterUrl]);

  // useEffect(() => {
  //   if (!state) return;
  //   setNotification({
  //     value: state.value,
  //     text: state.text,
  //   });
  // }, [state]);

  // useEffect(() => {
  //   if (notification.value === true) {
  //     setTimeout(() => {
  //       setNotification({
  //         value: false,
  //         text: "",
  //       });
  //     }, 5000);
  //   }
  // }, [notification]);

  const clickAddHandler = () => {
    navigate(`/settings/add/faq`);
  };

  const clickEditHandler = (id) => {
    navigate(`/settings/update/faq/${id}`);
  };

  const getRows = (info) => {
    let updatedInfo = info.map((row) => {
      return {
        id: row.id,
        question: row.translations[0]?.question || "",
        answer: row.translations[0]?.answer || "",
        tags: row.tags,
        tag:
          row.tags
            ?.map((tag) => tag?.tags_id?.translations?.[0]?.name)
            ?.filter(Boolean)
            ?.join(", ") || "",
      };
    });
    return updatedInfo;
  };

  useEffect(() => {
    setTableData(getRows(items));
  }, [items]);

  const updateStatusHandler = async (e, data) => {
    let obj;
    if (data.status === "published") obj = { status: "draft" };
    else obj = { status: "published" };
    // await CrudService.updateCommentInfo(obj, data.id);
    await CrudService.updateItem(`items/comments/${data.id}`, obj);

    getComments(`${filterUrl || ""}${sortUrl}`);
    setNotification({
      value: true,
      text: t("statusChanged"),
    });
  };

  async function deleteWithRelations(articleId) {
    try {
      if (!confirm("تأكيد الحذف مع جميع العلاقات؟")) {
        e.nativeEvent.stopImmediatePropagation();
      } else {
        await CrudService.removeItemWithFilter(`items/faq_translations`, {
          query: {
            filter: {
              faq_id: { _eq: articleId },
            },
          },
        });

        await CrudService.removeItemWithFilter(`items/faq_tags`, {
          query: {
            filter: {
              faq_id: { _eq: articleId },
            },
          },
        });

        await CrudService.removeItemWithFilter(`items/projects_faq`, {
          query: {
            filter: {
              faq_id: { _eq: articleId },
            },
          },
        });

        await CrudService.deleteItem("faq", articleId);

        console.log("تم الحذف بنجاح مع جميع العلاقات");
        getItems(filterUrl);
        setNotification({
          value: true,
          color: "success",
          text: t("deleteSuccessfully"),
        });
      }
    } catch (error) {
      console.error("حدث خطأ أثناء الحذف:", error);
    }
  }

  const dataTableData = {
    columns: [
      {
        Header: "الوسوم",
        accessor: "tag",
        width: "10%",
        // hidden: true,
        Cell: ({ value }) => <DefaultCell value={value} />,
      },
      {
        Header: "السؤال",
        accessor: "question",
        width: "70%",
        Cell: ({ value }) => <DefaultCell value={value} />,
      },

      // {
      //   Header: "الإجابة",
      //   accessor: "answer",
      //   width: "15%",
      //   Cell: ({ value }) => <DefaultCell value={value} />,
      // },
      {
        Header: "الإجراءات",
        disableSortBy: true,
        accessor: "",
        Cell: (info) => {
          return (
            <MDBox display="flex" alignItems="center">
              {(ability.can("edit", "faq") || isAdmin) && (
                <MDButton
                  sx={{ mx: 1, width: "auto", padding: "6px 12px" }}
                  variant="outlined"
                  color={"info"}
                  size="medium"
                  iconOnly
                  onClick={() => clickEditHandler(info.cell.row.original.id)}
                >
                  <Icon sx={{ fontWeight: "bold" }}>edit</Icon>
                  &nbsp;
                  <Tooltip title="عرض التفاصيل">
                    <span>عرض التفاصيل</span>
                  </Tooltip>
                </MDButton>
              )}
              {(ability.can("delete", "faq") || isAdmin) && (
                <MDButton
                  variant="outlined"
                  color={"error"}
                  size="medium"
                  iconOnly
                  sx={{ mx: 1, width: "auto", padding: "6px 12px" }}
                  onClick={() => deleteWithRelations(info.cell.row.original.id)}
                >
                  <Icon sx={{ fontWeight: "bold" }}>delete</Icon>
                  &nbsp;
                  <Tooltip title="حذف">
                    <span> حذف </span>
                  </Tooltip>
                </MDButton>
              )}
              {info.cell.row.original.status === "draft" ? (
                <MDButton
                  sx={{ mx: 1, width: "auto", padding: "6px 12px" }}
                  variant="outlined"
                  color={"info"}
                  size="medium"
                  iconOnly
                  onClick={(e) =>
                    updateStatusHandler(e, info.cell.row.original)
                  }
                >
                  <Icon sx={{ fontWeight: "bold" }}>wifi</Icon>
                  &nbsp;
                  <Tooltip title=" نشر التعليق">
                    <span> نشر التعليق</span>
                  </Tooltip>
                </MDButton>
              ) : (
                <MDButton
                  sx={{ mx: 1, width: "auto", padding: "6px 12px" }}
                  variant="outlined"
                  color={"error"}
                  size="medium"
                  iconOnly
                  onClick={(e) =>
                    updateStatusHandler(e, info.cell.row.original)
                  }
                >
                  <Icon sx={{ fontWeight: "bold" }}>wifi_off</Icon>
                  &nbsp;
                  <Tooltip title="إلغاء نشر التعليق">
                    <span>إلغاء نشر التعليق</span>
                  </Tooltip>
                </MDButton>
              )}
            </MDBox>
          );
        },
      },
      ,
    ],
    rows: tableData,
  };

  const setFilterTxt = (txt) => {
    const filter = txt
      ? `&filter[translations][question][_contains]=${txt}`
      : null;

    filter ? setFilterUrl(filter) : getItems("");
  };

  return (
    <DefaultLayout>
      {/* {notification.value && (
        <MDAlert color="info" my="20px">
          <MDTypography variant="body2" color="white">
            {notification.text}
          </MDTypography>
        </MDAlert>
      )} */}
      <MDBox pt={3} pb={3} mb={3}>
        {/* <Card> */}
        <MDBox
          p={3}
          lineHeight={1}
          display="flex"
          justifyContent="space-between"
        >
          <MDTypography variant="h5" fontWeight="medium" color="info">
            {t("faq")}
          </MDTypography>
          <MDBox display="flex">
            {(ability.can("create", "faq") || isAdmin) && (
              // <IconButton size="large" onClick={clickAddHandler}>
              //   <Add color="info" />
              // </IconButton>
              <MDButton
                onClick={clickAddHandler}
                variant="outlined"
                color={"info"}
                size="medium"
                iconOnly
                sx={{ mx: 1, width: "auto", padding: "6px 12px" }}
              >
                <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                &nbsp;
                <Tooltip title=" إضافة جديد">
                  <span>إضافة جديد </span>
                </Tooltip>
              </MDButton>
            )}
          </MDBox>
        </MDBox>
        <MDBox display="flex" alignItems="center" justifyContent="center">
          <MDBox width={"60%"}>
            <DataTable
              canSearch={true}
              filterTxt={setFilterTxt}
              // showFilter={showFilter}
              // setFilterUrl={setFilterUrl}
              setLimitChange={setLimitChange}
              table={dataTableData}
              meta={meta}
              setPage={setPage}
              setSortVal={setSortVal}
              pageNum={page}
              isSorted={false}
            />
          </MDBox>
        </MDBox>
        {/* </Card> */}
      </MDBox>
    </DefaultLayout>
  );
}

export default Faqs;
